
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/magazin",
      function () {
        return require("private-next-pages/magazin/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/magazin"])
      });
    }
  